import axios from 'axios'
import {
    get,
    post,
    getfile
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 花名册列表 
export function getList(params) {
    return get(`${HOST}personnel-manager/list`, params)
}
// 获取最大最小年龄
export function getAge(params) {
    return get(`${HOST}personnel-manager/getAge`, params)
}
// 退休人员列表
export function retireList(params) {
    return get(`${HOST}personnel-manager/retireList`, params)
}
// 人员历史修改版本列表
export function getHistoryList(params) {
    return get(`${HOST}personnel-manager-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
    return get(`${HOST}personnel-manager-history/get`, params)
}
// 批量导出花名册
export function listExport(params) {
    return getfile(`${HOST}personnel-manager/listExport`, params)
}
// 批量导出死亡人员列表
export function deathPersonnelManagerListExport(params) {
    return getfile(`${HOST}death-personnel-manager/listExport`, params)
}
// 批量导出退休人员花名册
export function retireListExport(params) {
    return getfile(`${HOST}personnel-manager/retireListExport`, params)
}
// 历史查询列表
export function getJobList(params) {
    return get(`${HOST}personnel-manager-job/list`, params)
}
// 历史查询详情
export function getJobDetial(params) {
    return get(`${HOST}personnel-manager-job/get`, params)
}
// 批量导出历史查询花名册
export function personnelMangerJobExport(params) {
    return getfile(`${HOST}personnel-manager-job/personnelMangerJobExport`, params)
}
// 导出花名册模板
export function importTemplate() {
    return getfile(`${HOST}personnel-manager/importTemplate`)
}
// 导入花名册
export function importPersonnelManager(params) {
    return post(`${HOST}personnel-manager/importPersonnelManager`, params)
}
// 减员操作  /personnel-manager/updatePositionStatus

export function updatePositionStatus(params) {
    return post(`${HOST}personnel-manager/updatePositionStatus`, params)
}
// 退休转死亡
export function updateMfPositionStatus(params) {
    return post(`${HOST}personnel-manager/updateMfPositionStatus`, params)
}
// 人员详情
export function personnelGet(params) {
    return get(`${HOST}personnel-manager/personnelGet/${params}`)
}
// 添加人员
export function savePersonnelManager(params) {
    return post(`${HOST}personnel-manager/savePersonnelManager`, params)
}
// 修改人员
export function updatePersonnelManager(params) {
    return post(`${HOST}personnel-manager/updatePersonnelManager`, params)
}
//组织结构树
export function getTreeList(params) {
    return get(`${HOST}organization-info/treeList/`, params)
}
//根据类型查询字典下拉列表
export function listByType(params) {
    return get(`${HOST}sys-dict/listByType`, params)
}
// 设置到期提醒
export function setRemind(params) {
    return post(`${HOST}personnel-remind/save`, params)
}
// 获取到期提醒设置
export function getRemind() {
    return get(`${HOST}personnel-remind/get`)
}
// 到期提醒列表
export function remindList(params) {
    return get(`${HOST}personnel-remind/remindList`, params)
}
// 人事到期提醒天数
export function personnelList(params) {
    return get(`${HOST}timing/personnelList`, params)
}

//民福部分接口begin
//死亡人员列表
export function getDeadlist(params) {
    return get(`${HOST}death-personnel-manager/list`, params)
}
//添加死亡人员death-personnel-manager/saveDeathPersonnelManager
export function saveDeathPersonnelManager(params) {
    return post(`${HOST}death-personnel-manager/saveDeathPersonnelManager`, params)
}
// 死亡人员详情/death-personnel-manager/personnelGet/{id}
export function deathPersonnelManagerPersonnelGet(params) {
    return get(`${HOST}death-personnel-manager/personnelGet/${params}`)
}
// 修改死亡人员/death-personnel-manager/updateDeathPersonnelManager
export function updateDeathPersonnelManager(params) {
    return post(`${HOST}death-personnel-manager/updateDeathPersonnelManager`, params)
}

// 死亡人员历史修改版本列表/death-personnel-manager-history/list
export function deathPersonnelManagerHistoryList(params) {
    return get(`${HOST}/death-personnel-manager-history/list`, params)
}
// 死亡人员 历史修改版本详情/death-personnel-manager-history/get

export function deathPersonnelManagerHistoryGet(params) {
    return get(`${HOST}/death-personnel-manager-history/get`, params)
}
// 导出死亡花名册模板
export function deathPersonnelManagerImportTemplate() {
    return getfile(`${HOST}death-personnel-manager/importTemplate`)
}
// 导入死亡花名册
export function deathPersonnelManagerImportDeathPersonnelManager(params) {
    return post(`${HOST}/death-personnel-manager/importDeathPersonnelManager`, params)
}
//-----退休
// 退休花名册列表 /personnel-manager/retireMfList
export function personnelManagerRetireMfList(params) {
    return get(`${HOST}/personnel-manager/retireMfList`, params)
}
// 退休人员详情 /personnel-manager/retirePersonnelGet/{id}
export function personnelManagerRetirePersonnelGet(params) {
    return get(`${HOST}personnel-manager/retirePersonnelGet/${params}`)
}
// 添加退休人员 民政
export function personnelManagerSavePersonnelManager(params) {
    return post(`${HOST}personnel-manager/savePersonnelManager`, params)
}
// 修改退休人员 民政
export function personnelManagerUpdatePersonnelManager(params) {
    return post(`${HOST}personnel-manager/updatePersonnelManager`, params)
}
// 批量导出退休
export function personnelManagerRetireListExport(params) {
    return getfile(`${HOST}personnel-manager/retireListExport`, params)
}

//通知

// 添加退休人员 民福
export function personnelManagerSaveMfPersonnelManager(params) {
    return post(`${HOST}personnel-manager/saveMfPersonnelManager`, params)
}
// 修改退休人员 民福
export function personnelManagerUpdatePersonnelMfManager(params) {
    return post(`${HOST}personnel-manager/updatePersonnelMfManager`, params)
}
// 退休列表-下载模板 民福
export function importMfTemplate() {
    return getfile(`${HOST}personnel-manager/importMfTemplate`)
}
// 死亡列表 -下载模板 民福
export function deathPersonnelImportTemplate() {
    return getfile(`${HOST}death-personnel-manager/importTemplate`)
}
// 退休列表-上传excel 民福
export function importRetirePersonnelManager(params) {
    return post(`${HOST}personnel-manager/importRetirePersonnelManager`, params)
}
/**
 * 银行卡号列表模块
 */
// 银行卡号列表 新增 民福
export function addBankCardList(params) {
    return post(`${HOST}sys-bank-card/save`, params)
}

// 银行卡号列表 根据id删除 民福
export function deleteBankCardList(params) {
    return post(`${HOST}sys-bank-card/delete/${params}`)
}

// 银行卡号列表 查询 民福
export function getBankCardList(params) {
    return get(`${HOST}sys-bank-card/list`, params)
}

// 银行卡号列表 根据id修改 民福
export function updateBankCardList(params) {
    return post(`${HOST}sys-bank-card/update`, params)
}
// 银行卡号列表 下载模板 民福
export function bankCardImportTemplate(params) {
    return getfile(`${HOST}sys-bank-card/importTemplate`, params)
}

// 银行卡号列表 上传Excel 民福
export function importSysBankCard(params) {
    return post(`${HOST}sys-bank-card/importSysBankCard`, params)
}

// 批量导出退休 民福
export function personnelManagerRetireMFListExport(params) {
    return getfile(`${HOST}personnel-manager/retireMfListExport`, params)
}


//民福部分接口end


// WEBPACK FOOTER //
// ./src/views/PersonnelManagement/api/api.js